import React, {createContext} from 'react';
import {AlertSnackbarActionType, useAlertSnackbar} from '../alert-snackbar/alert-snackbar-hook';
import {AlertSnackbar, Severity, SnackBarMessage} from '../alert-snackbar/AlertSnackbar';

interface AppSnackbarContextType {
  showErrorMessage: (message: SnackBarMessage) => void;
  showSuccessMessage: (message: SnackBarMessage) => void;
}

export const AppSnackbarContext = createContext<AppSnackbarContextType>({
  showErrorMessage: () => ({}),
  showSuccessMessage: () => ({})
});

interface Props {
  children: React.ReactNode;
}

export function AppSnackbarProvider({children}: Props): React.ReactElement {
  const [snackbarState, dispatchSnackbarAction] = useAlertSnackbar();

  const showMessage = (message: SnackBarMessage, severity: Severity): void =>
    dispatchSnackbarAction({
      type: AlertSnackbarActionType.SHOW,
      severity,
      message
    });

  const showErrorMessage = (message: SnackBarMessage): void => showMessage(message, Severity.ERROR);
  const showSuccessMessage = (message: SnackBarMessage): void => showMessage(message, Severity.SUCCESS);

  return (
    <>
      <AlertSnackbar handleClose={(): void => dispatchSnackbarAction({type: AlertSnackbarActionType.HIDE})}
                     severity={snackbarState.severity}
                     message={snackbarState.message}
                     open={snackbarState.isOpen} />
      <AppSnackbarContext.Provider value={{showErrorMessage, showSuccessMessage}}>
        {children}
      </AppSnackbarContext.Provider>
    </>
  );
}

